import React from 'react';
import TermsOfService from './TermsOfService';

/** Unauthenticated / marketing entry for Terms of Service. */
const PublicTermsOfServicePage = (): JSX.Element => <TermsOfService publicView />;

export default PublicTermsOfServicePage;
